export default function parseBgStockMusic(t) {
  return {
    id: t.id,
    uri: t.previewUri,
    name: t.name,
  };
}



// WEBPACK FOOTER //
// ./src/api/parsers/bgStockMusic.js